import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const CreditCustomers = () => {

  const navigate = useNavigate();

  const [customers, setCustomers] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [search, setSearch] =
    useState("");

  // =========================================
  // FETCH CREDIT CUSTOMERS
  // =========================================

  const fetchCustomers = async () => {

    try {

      const res = await fetch(
        "/api/credit-customers"
      );

      const data = await res.json();

      setCustomers(
        data.customers || []
      );

    } catch (err) {

      console.log(err);

    } finally {

      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  // =========================================
  // FILTERED CUSTOMERS
  // =========================================

  const filteredCustomers =
    customers.filter(customer => {

      const fullName =

        `${customer.first_name || ""}
        ${customer.last_name || ""}`
          .toLowerCase();

      return (

        fullName.includes(
          search.toLowerCase()
        )

        ||

        customer.phone?.includes(
          search
        )

      );
    });

  // =========================================
  // TOTAL PENDING
  // =========================================

  const totalPending =
    filteredCustomers.reduce(

      (sum, customer) =>

        sum +

        Number(
          customer.total_pending || 0
        ),

      0
    );

  return (

  <div className="min-h-screen bg-[#F5F7FB] p-4 md:p-6 space-y-6">

      {/* ========================================= */}
      {/* HERO */}
      {/* ========================================= */}

      <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-3xl p-5 md:p-8 text-white shadow-xl">

        <div className="flex flex-col lg:flex-row justify-between lg:items-center gap-6">

          <div>

            <p className="uppercase tracking-widest text-indigo-200 text-sm">

              Customer Management

            </p>

            <h1 className="text-2xl md:text-4xl font-bold mt-2">

              Credit Customers

            </h1>

            <p className="mt-3 text-indigo-100">

              Monitor pending payments,
              rental credits and customer balances.

            </p>

          </div>

          <div className="hidden md:flex flex-col items-end">

            <div className="bg-white/10 backdrop-blur-md px-6 py-4 rounded-2xl border border-white/20">

              <p className="text-sm text-indigo-100">
                Total Pending
              </p>

              <h2 className="text-4xl font-bold mt-1">

                ₹{totalPending}

              </h2>

            </div>

          </div>

        </div>

      </div>

      {/* ========================================= */}
      {/* SEARCH + STATS */}
      {/* ========================================= */}
<div className="grid grid-cols-1 lg:grid-cols-12 gap-6">

        {/* SEARCH */}

       <div className="col-span-1 lg:col-span-8 bg-white rounded-3xl p-5 shadow-sm border border-gray-100">

          <div className="flex items-center gap-4">

            <div className="w-12 h-12 rounded-2xl bg-indigo-100 flex items-center justify-center text-xl">

              🔍

            </div>

            <input
              type="text"
              placeholder="Search customer by name or phone"
              value={search}
              onChange={(e) =>
                setSearch(e.target.value)
              }
              className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition"
            />

          </div>

        </div>

        {/* TOTAL CUSTOMERS */}

      <div className="col-span-1 lg:col-span-4 bg-white rounded-3xl p-5 md:p-6 shadow-sm border border-gray-100">

          <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-4">

            <div>

              <p className="text-sm text-gray-500">

                Total Customers

              </p>

              <h2 className="text-3xl md:text-4xl font-bold text-indigo-600 mt-3">

                {filteredCustomers.length}

              </h2>

            </div>

            <div className="w-16 h-16 rounded-2xl bg-indigo-100 flex items-center justify-center text-3xl">

              👥

            </div>

          </div>

        </div>

      </div>

      {/* ========================================= */}
      {/* CUSTOMER TABLE */}
      {/* ========================================= */}

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden">

        {/* HEADER */}

        <div className="px-5 md:px-8 py-6 border-b border-gray-100 flex flex-col sm:flex-row justify-between sm:items-center gap-4">

          <div>

            <h2 className="text-2xl font-bold text-gray-800">

              Credit Customer List

            </h2>

            <p className="text-sm text-gray-500 mt-1">

              Customers with outstanding rental balances

            </p>

          </div>

          <div className="bg-red-100 text-red-600 px-4 py-2 rounded-xl text-sm font-semibold">

            Pending Payments

          </div>

        </div>

        {/* TABLE */}

        <div className="overflow-x-auto">

         <table className="min-w-[900px] w-full">

            <thead className="bg-gray-50 text-gray-500 text-sm">

              <tr>

                <th className="text-left px-8 py-5">
                  Customer
                </th>

                <th className="text-left px-6 py-5">
                  Phone
                </th>

                <th className="text-left px-6 py-5">
                  Rentals
                </th>

                <th className="text-left px-6 py-5">
                  Paid
                </th>

                <th className="text-left px-6 py-5">
                  Pending
                </th>

                <th className="text-left px-6 py-5">
                  Status
                </th>

                <th className="text-right px-8 py-5">
                  Actions
                </th>

              </tr>

            </thead>

            <tbody>

              {loading ? (

                <tr>

                  <td
                    colSpan="7"
                    className="text-center py-20 text-gray-500"
                  >

                    Loading Customers...

                  </td>

                </tr>

              ) : filteredCustomers.length === 0 ? (

                <tr>

                  <td
                    colSpan="7"
                    className="text-center py-20 text-gray-500"
                  >

                    No credit customers found

                  </td>

                </tr>

              ) : (

                filteredCustomers.map(

                  (customer, index) => {

                    const pending =

                      Number(
                        customer.total_pending || 0
                      );

                    const paid =

                      Number(
                        customer.total_paid || 0
                      );

                    return (

                      <tr
                        key={index}
                        className="border-t border-gray-100 hover:bg-gray-50 transition"
                      >

                        {/* CUSTOMER */}

                        <td className="px-8 py-6">

                          <div className="flex items-center gap-4">

                            <div className="w-12 h-12 rounded-2xl bg-indigo-100 flex items-center justify-center font-bold text-indigo-600">

                              {
                                customer.first_name?.charAt(0)
                              }

                            </div>

                            <div>

                              <p className="font-semibold text-gray-800 text-base">

                                {customer.first_name}
                                {" "}
                                {customer.last_name}

                              </p>

                              <p className="text-sm text-gray-500 mt-1">

                                Credit Customer

                              </p>

                            </div>

                          </div>

                        </td>

                        {/* PHONE */}

                        <td className="px-6 py-6 text-gray-700 font-medium">

                          {customer.phone || "-"}

                        </td>

                        {/* RENTALS */}

                        <td className="px-6 py-6">

                          <span className="bg-indigo-100 text-indigo-600 px-3 py-1 rounded-full text-xs font-semibold">

                            {
                              customer.total_rentals || 0
                            }

                            {" "}
                            Rentals

                          </span>

                        </td>

                        {/* PAID */}

                        <td className="px-6 py-6 font-semibold text-emerald-600">

                          ₹{paid}

                        </td>

                        {/* PENDING */}

                        <td className="px-6 py-6 font-bold text-red-600 text-base">

                          ₹{pending}

                        </td>

                        {/* STATUS */}

                        <td className="px-6 py-6">

                          <span
                            className={`px-4 py-2 rounded-full text-xs font-semibold

                              ${
                                pending <= 0

                                  ? "bg-green-100 text-green-700"

                                  : pending < paid

                                  ? "bg-yellow-100 text-yellow-700"

                                  : "bg-red-100 text-red-700"
                              }
                            `}
                          >

                            {

                              pending <= 0

                                ? "Paid"

                                : pending < paid

                                ? "Partial"

                                : "Pending"

                            }

                          </span>

                        </td>

                        {/* ACTIONS */}

                        <td className="px-8 py-6 text-right">

                          <button
                            onClick={() =>
                              navigate(
                                `/customer/${customer.id}`
                              )
                            }
                            className="whitespace-nowrap bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-5 py-3 rounded-2xl font-medium hover:shadow-lg transition"
                          >

                            View Details

                          </button>

                        </td>

                      </tr>
                    );
                  }
                )

              )}

            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
};

export default CreditCustomers;